import { connect } from 'react-redux'
import ShareLessonModal from './share-lesson-modal'
import { getShareLessonRequest } from '../pages/lessons-list/redux/lessons.selectors'
import { shareLesson } from '../pages/lessons-list/redux/lessons.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = (state, { id }) => {
  const shareLessonRequest = getShareLessonRequest(state)
  return {
    key: id,
    presentationId: id,
    pending: shareLessonRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onSubmit: ({ emails, recaptchaToken, message }) => {
    return dispatch(
      shareLesson(stateProps.presentationId, {
        emails: emails.map(email => email.value),
        recaptchaToken,
        message
      })
    )
      .then(() => {
        return toast.success('Your resources are on the way!')
      })
      .catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ShareLessonModal)
